'use strict';

import 'angular';

import submitModule from './submit';
import modalDirective from './modal';

const MODULE_NAME = 'brg.rest.buttons';

var app = angular.module(MODULE_NAME, [
	submitModule,
]);

// Generic modal directive
app.directive('brgRestModal', modalDirective({}));

export default MODULE_NAME;
